import React from 'react';
export class PlacesSearchBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.searchOriginAddress !== null) {
            this.setState({ searchValue: nextProps.searchOriginAddress });
        }
    }

    render() {

        const {
            wrapperId,
            searchBoxId,
            placeholder,
            searchOriginAddress
        } = this.props;
        
        return (
            <div id={wrapperId}>
                <div className="search-wrapper">
                    <input id={searchBoxId}
                        className="controls"
                        type="text"
                        placeholder={placeholder}
                        onFocus={this.showReset}
                        onChange={this.handleChange}
                        onBlur={this.hideReset}
                        value={this.state.searchValue}
                        />
                    <span id="placeReset" className="icon-cross2 places-reset"
                        onClick={this.resetSearch.bind(this)}></span>
                    <span id="placeSubmit" className="icon-search places-submit"></span>
                </div>
            </div>);
    }

    handleChange(event) {
        this.setState({searchValue: event.target.value});
    }

    showReset() {
        var resetIcon = document.getElementById("placeReset");
        resetIcon.style.display = "block";
    }

    hideReset(event) {
        if (!event.target.value) {
            var resetIcon = document.getElementById("placeReset");
            resetIcon.style.display = "none";
        }
    }

    resetSearch() {
        var searchBox = document.getElementById(this.props.searchBoxId);
        searchBox.focus();
        this.setState({ searchValue: "" });
    }
}
